import React from 'react'
import { MdOutlinePersonAddAlt1 } from "react-icons/md";
import { darkenColor, primaryColor } from '../../utils/comman/Common';

import { useSelector } from 'react-redux';

export default function Head(props) {
    const {
        AddNewClients,
        search,
        enterTxnsearch,
        clearSearchData,
        bgColor
    } = props
    const roles = useSelector(state => state.authReducer?.auth?.roles);
  return (
    <div class="head">
            <h3 style={{marginTop:'3px'}} className="hide-on-mobile">User List</h3>
            <div className="search-filter-mobile-view">
              <div>
                {
                 
              <button style={{height:'33px', backgroundColor: primaryColor}} class="btn" type="button" onClick={AddNewClients}>
                <MdOutlinePersonAddAlt1 size={25} />
              </button>}
              </div>
              
                <div
                  style={{
                    backgroundColor: primaryColor,
                    marginBottom: "5px",
                  }}
                  className="search allsearch"
                >
                  <form autocomplete="off" action="#">
                    <div className="autocomplete">
                      <input
                        id="myInput"
                        type="text"
                        name=""
                        style={{ backgroundColor: primaryColor }}
                        placeholder="Search"
                        value={search}
                        onChange={(event) => enterTxnsearch(event)}
                        // onChange={searchdata}
                      />
                      <button
                        type="button"
                         onClick={clearSearchData}
                        style={{
                          position: "absolute",
                          backgroundColor: darkenColor(primaryColor),
                        }}
                        className="search-btn"
                      ></button>
                  
                    </div>
                  </form>
                </div>
                </div>
            </div>
  )
}
